// ========================================
// ================== V3 ==================
// ========================================

import { put } from "redux-saga/effects";
import axios from "../../axios";
import * as actions from "../actions/index";
import * as kApi from "../../constants/api";
import { Auth } from "aws-amplify";
import { refreshTokenSaga } from "./_LocalRefreshToken";

export function* initFetchCodeSaga(action) {
  try {
    const response = yield axios.get(kApi.API_Q_CODE, {
      headers: {
        Authorization: Auth.user.signInUserSession.idToken.jwtToken,
      },
    });
    if (response.data.code)
      yield put(actions.fetchCodeSuccess(response.data.code));
    else yield put(actions.fetchCodeSuccess(response.data));
  } catch (error) {
    try {
      const refreshToken = yield refreshTokenSaga();
      const response = yield axios.get(kApi.API_Q_CODE, {
        headers: {
          Authorization: refreshToken.signInUserSession.idToken.jwtToken,
        },
      });
      if (response.data.code)
        yield put(actions.fetchCodeSuccess(response.data.code));
      else yield put(actions.fetchCodeSuccess(response.data));
    } catch (error) {
      yield put(actions.fetchCodeFail(error));
    }
  }
}
